import React, { useRef, useState, useCallback } from 'react';
import '../architecture.module.css'
import { DialogComponent } from '@syncfusion/ej2-react-popups';
import moment from 'moment';
import { NumericTextbox } from 'op2mise-react-widgets';
import { SCHEDULE_TYPE } from '../ChannelArchitecture.d';
import '../ChannelArchitecture.css';

const MIN_GRADE_VALUE = 1;
const MAX_GRADE_VALUE = 10;
const MIN_MINUTAGE_VALUE = 0;
const MAX_MINUTAGE_VALUE = 60;

const ModifyGradingAndMinutage = (props) => {
    const {
        isOpen,
        closeModal,
        handleUpdate,
        schedule,
        type,
    } = props
    const inputRef = useRef(null);
    const [numericError, setNumericError] = useState('');
    const scheduleValue = type === 'grade' ? schedule.grade : schedule.minutage;
    const scheduleStartTime = schedule.startTime;
    const getLongDay = (date) => {
        return moment(date).format('ddd')
    }

    const NumericlInputfield = useCallback(() => {
        const isScheduleGrade = type === SCHEDULE_TYPE.GRADE;
        const min = isScheduleGrade ? MIN_GRADE_VALUE : MIN_MINUTAGE_VALUE;
        const max = isScheduleGrade ? MAX_GRADE_VALUE : MAX_MINUTAGE_VALUE;

        const initialValue = isScheduleGrade ? scheduleValue : parseFloat(scheduleValue?.toFixed(2) ?? 0);

        // Uncontrolled + ref: EJ2 onChange fires on blur, which races with the
        // Save button's click, so reading state on click can be stale.
        // Reading .value via ref instead avoids that race.
        return (
          <>
            <NumericTextbox
                key={`${type}-${scheduleValue}-${isOpen}`}
                ref={inputRef}
                format={isScheduleGrade ? '##' : null}
                value={initialValue}
                min={min}
                max={max}
                showSpinButton={false}
                enabled={true}
                cssClass="e-op2mise-numeric-textbox"
                width='254px'
                style={{
                    fontSize: '12px',
                    color: '#6D6D73',
                    textAlign: 'start',
                    padding: '0px 15px',
                    height: '34px !important',
                    margin: '0px',
                }}
                label=""
            />
          </>
        )
    }, [scheduleValue, type, isOpen])

    return (
        <DialogComponent
            cssClass='e-op2mise-dialog'
            isModal={true}
            width='456px'
            open={isOpen}
            overlayClick={closeModal}
            radius='5px'
            buttons={[
                {
                    click: () => { closeModal() },
                    buttonModel: {
                        content: 'Close',
                        cssClass: 'e-flat-btn',
                    },
                },
                {
                    click: () => {
                      const currentValue = inputRef.current?.value;
                      if (type === SCHEDULE_TYPE.MINUTAGE && (currentValue === null || currentValue === undefined)) {
                        setNumericError('Minutage is required');
                        return;
                      }

                      setNumericError('');
                      handleUpdate(currentValue);
                      closeModal();
                    },
                    buttonModel: {
                        content: 'Update',
                        cssClass: 'e-primary-btn',

                    },
                },
            ]}
        >
            <div style={{
                display: 'flex',
                flexDirection: 'column',
                gap: 20,
                padding: type === SCHEDULE_TYPE.GRADE ? '10px 0 0px 10px' : '10px 10px 0 10px',
                height: 'fit-content',
            }}>
                <div
                    style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'flex-start',
                        gap: 7,
                        fontSize: '20px',
                    }}
                >
                    Modify Block | { }
                    <div style={{ color: '#6D6D73' }}>
                        {`${getLongDay(scheduleStartTime)}
                        ${moment(scheduleStartTime).format('HH:mm')}`}
                    </div>
                </div>
                <div style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                }}>
                    <label style={{
                        fontWeight: 400,
                        color: '#0C212B',
                    }}>{type === SCHEDULE_TYPE.GRADE
                        ? 'Grading'
                        : 'Minutage'}
                        <span style={{
                            fontSize: '12px',
                        }}>*</span>
                    </label>
                    <div style={{ display: 'flex', flexDirection: 'column' }}>
                      {NumericlInputfield()}
                      <div
                        className="errorValidation"
                        style={{
                          whiteSpace: 'initial',
                          width: '100%',
                          textAlign: 'right',
                          marginTop: '10px',
                        }}
                      >
                        {numericError}
                      </div>
                    </div>
                </div>
            </div>
        </DialogComponent >
    )
}

export default ModifyGradingAndMinutage
